<template>
  <overlay-scrollbars
    :options="{ className: 'content-container flex-column os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <section class="content large-padding">
      <div class="grid-x align-items-center">
        <!-- <div class="cell large-12">
          State: {{state}}
        </div> -->

        <div class="cell auto">
          <h2 class="no-margin">Oppgjør <span v-if="objekt">#{{objekt.Objektnr}}</span></h2>
          <span class="opacity-60">
            {{state.info}}
          </span>
        </div>

        <!-- Already Invoiced -->
        <div class="cell shrink" v-if="state.finished">
          <div class="grid-x grid-margin-x">
            <div class="cell shrink">
              <div class="dl-wrap align-right">
                <span class="dl dt align-right">Fakturert</span>
                <span class="dl dd align-right" v-if="bilag">{{bilag.Dato | avantidate}}</span>
              </div>
            </div>
            <div class="cell shrink">
              <div v-if="bilag && bilag.utbetaltdato != null" class="dl-wrap">
                <span class="dl dt align-right">Utbetalt dato i 24</span>
                <span class="dl dd align-right">{{bilag.utbetaltdato | avantidate}}</span>
              </div>
              <div v-else class="dl-wrap">
                <span class="dl dt align-right">Planlagt utbetalt dato</span>
                <span class="dl dd align-right">{{objekt.Oppgjorbetalt | avantidate}}</span>
              </div>
            </div>
            <div class="cell shrink">
              <div class="dl-wrap align-right">
                <span class="dl dt align-right">Fakturanr</span>
                <span class="dl dd align-right" v-if="bilag && bilag.twentyfourseven_transaction_number">{{bilag.twentyfourseven_transaction_number}}</span>
                <span class="dl dd align-right" v-else>{{objekt.Oppgjorbilagsnr || '-'}}</span>
              </div>
            </div>

            <div class="cell shrink" v-if="state.creditable && isPresenceOwner && isAccounting">
              <a href="javascript:javascript:;" @click="creditSetlement" class="button action glyph">
                <svg width="16px" height="16px" viewBox="0 0 16 16">
                  <use xlink:href="/static/sprites.svg#button-glyph-close"></use>
                </svg>
                <span>Krediter oppgjør</span>
              </a>
            </div>
            <!-- <div class="cell shrink" v-if="bilag && bilag.Bilagsid">
              <a href="javascript:javascript:;" @click="showBilagsPdf" class="button action glyph">
                <svg width="16px" height="16px" viewBox="0 0 16 16">
                  <use xlink:href="/static/sprites.svg#button-glyph-contract"></use>
                </svg>
                <span>Vis faktura</span>
              </a>
            </div> -->
          </div>
        </div>
      </div>
      <div class="card large-padding margin-top no-margin-bottom">
        <TheLoader :active="loading" :small="true"/>

        <template v-if="!loading">
          <TheEmptyList v-if="!state.finished && !state.editableAs && !isReturnInvoice" :title="'Ikke ennå klar før fakturering...'" :large="false" :icon="'button-glyph-object'"/>

          <div class="alert error inline-alert active" v-if="showErrorMessage()">
            <div class="alert-wrapper">
              <span class="icon alert-icon error">
                <svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-alert-error"></use></svg>
              </span>
              <div class="alert-content">
                <div class="alert-title">Feilmelding<span class="opacity-60">, {{objekt.last_oppgjor_logg.CreatedAt | avantidatetime}}</span></div>
                <div class="alert-subtitle">{{objekt.last_oppgjor_logg.Melding}}</div>
              </div>
            </div>
          </div>

          <template v-if="state.editableAs">
            <div class="grid-x">
              <!-- Popover -->
              <div class="cell auto">
                <span class="button-container has-popover" :class="{'popover-active': varePopoverActive }"
                      @click="toggleVarePopover()">
                  <span class="button action glyph" :class="{'disabled': !isPresenceOwner}"><svg width="16px" height="16px" viewBox="0 0 16 16"><use
                    xlink:href="/static/sprites.svg#button-glyph-add"></use></svg> <span>Ny fakturalinje</span></span>
                  <span class="popover align-x-left align-y-bottom xlarge">
                    <overlay-scrollbars
                      :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
                    <ul>
                      <li v-for="item in vareOptions.sort(sortLinevalues).filter(x => x.status)"
                          v-bind:key="'add-' + item.data.Vareid">
                        <a href="javascript:;" @click="addVare(item)" class="add-form-line popover-form-line"><span>{{item.data.Beskrivelse || item.val}} <span
                          class="label">{{item.val}}</span></span></a>
                      </li>
                    </ul>
                    </overlay-scrollbars>
                  </span>
                </span>
              </div>
              <!-- // Popover -->
            </div>
          </template>

          <!-- <div class="grid-x grid-padding-x">
            <div class="cell">
              {{state}}<br>
              ok for draft: {{okForDraftSave}}<br>
              regnskap: {{isRegnskapsBruker()}}<br>
              objekt.OppgjorbilagsIdDraft (y): {{objekt.OppgjorbilagsIdDraft}}<br>
              objekt.Oppgjorbilagsnr: (n) {{objekt.Oppgjorbilagsnr}}<br>
              bilag.twentyfourseven_transaction_number (n): {{bilag ? bilag.twentyfourseven_transaction_number : '-'}}
            </div>
          </div> -->

          <table class="medium padding margin-top margin-bottom" v-if="state.finished || state.editableAs">
            <thead>
            <tr>
              <th>Beskrivelse</th>
              <th>Kode</th>
              <th class="align-right">Pris eks. mva</th>
              <th class="align-right">Pris inkl. mva</th>
              <th class="align-right">&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="line in visibleBilagLines" v-bind:key="line.Internalid">
              <td>
                <span v-if="!state.editableAs || state.finished">{{line.Beskrivelse | truncate(80)}}</span>
                <div v-else class="input-container minimal no-margin large text">
                  <input type="text" v-model="line.Beskrivelse" maxlength="100" :disabled="!isPresenceOwner">
                  <span class="glyph"><svg viewBox="0 0 44 44"><use
                    xlink:href="/static/sprites.svg#button-glyph-pencil"></use></svg></span>
                </div>
              </td>
              <td>
                <span class="label">{{line.Varenr}}</span>
              </td>
              <td class="align-right opacity-60">
                {{line.Belop | thousandsFloat}}
              </td>
              <td class="align-right">
                <span v-if="!state.editableAs || state.finished">{{line.Beloptotal | thousandsFloat}}</span>
                <TheDecimalInputTable v-else v-model="line.Beloptotal"
                  containerClassName="input-container minimal align-right no-margin small"
                  @blur="onValueChange($event, line)"
                  :disabled="!isPresenceOwner"/>
              </td>
              <td class="align-right">
                <a href="javascript:;"
                   v-if="isPresenceOwner && state.editableAs && line.Varetype != 'O' && !(line.Varenr == 'OPPGJØR' || line.Varenr == 'FOTO')"
                   @click="delBilagLine(line)" class="button action input-action glyph glyph-only no-margin">
                  <svg width="16px" height="16px" viewBox="0 0 16 16">
                    <use xlink:href="/static/sprites.svg#button-glyph-delete"></use>
                  </svg>
                </a>
              </td>
            </tr>
            </tbody>
            <tfoot class="highlight">
            <tr>
              <td colspan="2"><strong>Total til utbetaling</strong></td>
              <td class="align-right"><strong>{{totalPriceExc}}</strong></td>
              <td class="align-right"><strong>{{totalPriceInc}}</strong></td>
              <td>&nbsp;</td>
            </tr>
            </tfoot>
          </table>

          <div class="grid-x">
            <div class="cell auto"></div>

            <!-- Already Invoiced -->
            <div class="cell shrink" v-if="state.finished">
              <!-- Annuler -->
              <!-- Krediter -->
            </div>

            <!-- Normal draft -->
            <div class="cell shrink" v-else-if="state.editableAs === 'draft' || state.editableAs === 'normal'">
              <template v-if="!isPresenceOwner">
                <a href="javascript:;" class="button primary submit large" disabled>Lagre</a>
              </template>
              <template v-else>
                <a v-if="loadingSave && !loadingPush" href="javascript:;"
                  class="button primary submit large loading">Lagrer selgerfaktura...<span
                  class="loader-spinner"></span></a>
                <a v-else-if="!loadingSave && !loadingPush" href="javascript:;"
                  class="button primary submit large" @click="saveAction(false)">Lagre selgerfaktura</a>
                <a v-else href="javascript:;"
                  class="button primary submit large" disabled>Lagre</a>
              </template>

              <template v-if="!isPresenceOwner || !isRegnskapsBruker() || !okForDraftSave">
                <a href="javascript:;" class="button primary submit large" disabled>Dytt til 24Seven</a>
              </template>
              <template v-else-if="isRegnskapsBruker()">
                <a v-if="loadingPush"
                  href="javascript:;"
                  class="button primary submit large loading">Dytter oppgjør til 24Seven...<span
                  class="loader-spinner"></span></a>
                <a
                  v-else-if="(!loadingSave && !loadingPush && objekt.OppgjorbilagsIdDraft && !objekt.Oppgjorbilagsnr && ((bilag && !bilag.twentyfourseven_transaction_number) || objekt.innlevav.force_twentyfourseven === true))"
                  href="javascript:;"
                  class="button primary submit large" @click="saveAction(true)">Dytt Oppgjør til 24Seven</a>
                <a
                  v-else
                  href="javascript:;"
                  class="button primary submit large"
                  disabled>Dytt til 24Seven</a>
              </template>
            </div>
          </div>

          <div class="alert error inline-alert active" style="margin-top: 2rem;" v-if="!isPresenceOwner || !isRegnskapsBruker() || !okForDraftSave || checkDraftError !== false">
            <div class="alert-wrapper">
              <span class="icon alert-icon error">
                <svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-alert-error"></use></svg>
              </span>
              <div class="alert-content">
                <div class="alert-title">{{checkDraftError}}</div>
              </div>
            </div>
          </div>

        </template>
      </div>
    </section>

    <section class="content transparent-gray flex-grow"></section>
  </overlay-scrollbars>
</template>

<script>
import bus from '@/plugins/event-bus'
import ObjektService from '@/services/ObjektService'
import InstillingerService from '@/services/InstillingerService'
import TheAutoCompleteInput from '../Inputs/TheAutoCompleteInput'
import moment from 'moment'
import accounting from 'accounting-js'
import {mapGetters} from 'vuex'

const KUNST_MAPPING = [
  'AL',
  'BL',
  'CL',
  'DL',
  'EL',
  'AS',
  'BS',
  'CS',
  'DS',
  'ES'
]

/** Lagerleie varekode per department (Avdelingsid). null = default/fallback */
const LAGERLEIE_VAREKODE_CONFIG = [
  { avdelingsid: 2, varekode: 'LLUKE2' }, // Vin
  { avdelingsid: null, varekode: 'LLUKE' } // Default
]

const getLagerleieVarekode = (avdelingsid) => {
  const config = LAGERLEIE_VAREKODE_CONFIG.find(c => c.avdelingsid === avdelingsid) ||
                 LAGERLEIE_VAREKODE_CONFIG.find(c => c.avdelingsid === null)
  return config ? config.varekode : 'LLUKE'
}

export default {
  name: 'KundeKontraktObjektTabSelgerBilag',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    TheAutoCompleteInput
  },
  props: {
    objekt: {
      type: Object,
      required: true
    }
  },
  data () {
    return this.getDefaultData()
  },
  computed: {
    ...mapGetters(['getUser']),
    state: function () {
      let creditable = false
      // console.log('this.objekt.Oppgjor', this.objekt.Oppgjor)
      if (this.objekt.Oppgjorbilagsnr && this.objekt.Oppgjor === 'T') {
        // Fakturert
        let infoText = ''
        if (this.bilag && this.bilag.twentyfourseven_transaction_number) {
          infoText = 'Fakturert'
          creditable = true
        } else {
          infoText = 'Fakturert, ikke sendt til regnskap'
          creditable = true
        }

        return {finished: true, editableAs: null, info: infoText, creditable: creditable}
      } else if (this.objekt.Oppgjorbilagsnr && this.bilag) {
        // Fakturert: Feil Fakturert verdi
        let infoText = ''
        if (this.objekt.Oppgjorbetalt !== null && this.bilag.twentyfourseven_transaction_number !== null) {
          infoText = 'Fakturert'
          creditable = true
        } else {
          infoText = 'Fakturert, ikke sendt til regnskap'
        }

        return {finished: true, editableAs: null, info: infoText, creditable: creditable}
      } else if (this.objekt.Salgspris && this.objekt.mottaker) {
        // Draft mode - men kan trykka fakturer. Ikke ennå fakturert

        return {finished: false, editableAs: 'draft', info: 'Ikke ennå fakturert'}
      } else {
        // Draft mode - kan ikke trykke fakturer.
        return {finished: false, editableAs: 'draft', info: 'Ikke ennå tilslag'}
      }
    },
    vareOptions: function () {
      return this.vareList.filter((i) => {
        if (i.data.Varekode === 'OBJEKT') {
          return false
        }

        if (i.data.Varekode === 'OPPGJØR') {
          return false
        }

        if (i.data.Varekode === 'FOTO') {
          return false
        }

        if (i.data.Varekode === getLagerleieVarekode(this.objekt.Avdelingsid) && this.lagerleieWeeks === null) {
          return false
        }

        return true
        // return !i.Used
      })
    },
    lagerleieWeeks: function () {
      // Check objekt
      if (!this.objekt.Lagerleieinfo || !this.objekt.Lagerleiedato) {
        return null
      }

      // Also check mottaker
      // if (!this.objekt.mottaker || !this.objekt.mottaker.SendLagerleieinfo) {
      //   console.log('test 2')
      //   return null
      // }

      const today = moment().format('YYYY-MM-DD')
      const ldato = moment(moment(this.objekt.Lagerleiedato).format('YYYY-MM-DD'))
      const diff = ldato.diff(today)

      // Only if today or less than today's date
      if (diff <= 0) {
        const totd = Math.abs(moment.duration(diff).as('days'))
        const totw = Math.floor(totd / 7) + ((totd % 7) > 0 ? 1 : 1)
        // weeks from object
        const weeks = this.objekt.lagerleie_weeks ? this.objekt.lagerleie_weeks : totw

        console.log({
          weeks: weeks,
          from: ldato.format('YYYY-MM-DD'),
          till: today
        })
        return {
          weeks: weeks,
          from: ldato.format('YYYY-MM-DD'),
          till: today
        }
      }

      return null
    },
    totalPriceInc: function () {
      let retval = 0

      this.bilagLines.forEach((line) => {
        if (line.Beloptotal !== null && line.Beloptotal !== '') {
          if (line.Varetype === 'O') {
            retval += parseFloat(line.Beloptotal)
          } else {
            retval += parseFloat(line.Beloptotal)
          }
        }
      })

      return accounting.formatNumber(retval, {precision: 2, thousand: ' '})
    },
    totalPriceExc: function () {
      let retval = 0

      this.bilagLines.forEach((line) => {
        if (line.Belop !== null && line.Belop !== '') {
          if (line.Varetype === 'O') {
            retval += parseFloat(line.Belop)
          } else {
            retval += parseFloat(line.Belop)
          }
        }
      })

      return accounting.formatNumber(retval, {precision: 2, thousand: ' '})
    },
    currentSalarPris: function () {
      const index = this.bilagLines.findIndex(x => x.Varenr === 'OPPGJØR')

      if (index !== -1) {
        return this.bilagLines[index].Belop
      }

      return 0
    },
    currentObjektPris: function () {
      const index = this.bilagLines.findIndex(x => x.Varenr === this.objekt.Objektnr)

      if (index !== -1) {
        return this.bilagLines[index].Belop
      }

      return 0
    },
    visibleBilagLines: function () {
      return this.bilagLines
    },
    isPresenceOwner: function () {
      return this.$store.getters['presence/isOwner'](this.presenceChannelName)
    },
    okForDraftSave: function () {
      if (!this.objekt.innlevav || !this.objekt.innlevav.Kundenr) {
        return false
      }
      if (!this.objekt.innlevav.kundeadresse || this.objekt.innlevav.kundeadresse.length < 1) {
        return false
      }
      if (!this.objekt.innlevav.kundeadresse.filter(i => i.Type === 'faktura')) {
        return false
      }
      if (!this.objekt.innlevav.kundeadresse.filter(i => i.Type === 'levering')) {
        return false
      }

      // new validation: start
      const kundeKontonr = this.objekt.innlevav.Kontonr ? this.objekt.innlevav.Kontonr : ''
      const kontraktKontonummer = this.objekt.kontrakt.Kontonummer ? this.objekt.kontrakt.Kontonummer : ''

      if (this.objekt.innlevav.force_twentyfourseven === true) {
        return true
      } else if (kontraktKontonummer && kontraktKontonummer.match(/^\d+$/) && kontraktKontonummer.length === 11 && kontraktKontonummer !== '00000000000') {
        return true
      } else if (kundeKontonr && kundeKontonr.match(/^\d+$/) && kundeKontonr.length === 11 && kundeKontonr !== '00000000000') {
        return true
      } else if (this.objekt.innlevav.Iban && this.objekt.innlevav.Swift) {
        return true
      } else {
        return false
      }
    },
    isAccounting: function () {
      return this.hasAccess('accounting')
    },
    checkDraftError: function () {
      if (!this.isPresenceOwner || !this.isRegnskapsBruker()) {
        return 'The user does not have permission!'
      }

      if (!this.objekt.innlevav || !this.objekt.innlevav.Kundenr) {
        return 'The Kunde number is invalid!'
      }

      if (!this.objekt.innlevav.kundeadresse || this.objekt.innlevav.kundeadresse.length < 1) {
        return 'The kunde address does not exist!'
      } else {
        if (!this.objekt.innlevav.kundeadresse.filter(i => i.Type === 'faktura')) {
          return 'The faktura address is invalid!'
        }
        if (!this.objekt.innlevav.kundeadresse.filter(i => i.Type === 'levering')) {
          return 'The levering address is invalid!'
        }
      }

      if (!this.objekt.OppgjorbilagsIdDraft) {
        return 'The draft invoice does not exist!'
      }

      if (this.objekt.Oppgjorbilagsnr) {
        console.log('The object already has an invoice number!')
      }

      if (this.bilag && this.bilag.twentyfourseven_transaction_number) {
        console.log('The invoice has already been sent to the 24SO!')
      }

      // new validation: start
      const kundeKontonr = this.objekt.innlevav.Kontonr ? this.objekt.innlevav.Kontonr : ''
      const kontraktKontonummer = this.objekt.kontrakt.Kontonummer ? this.objekt.kontrakt.Kontonummer : ''

      if (this.objekt.innlevav.force_twentyfourseven === false) {
        if (!kontraktKontonummer || !kontraktKontonummer.match(/^\d+$/) || kontraktKontonummer.length !== 11 || kontraktKontonummer === '00000000000') {
          return 'The contract customer number is invalid!'
        }

        if (!kundeKontonr || !kundeKontonr.match(/^\d+$/) || kundeKontonr.length !== 11 || kundeKontonr === '00000000000') {
          return 'The customer number is invalid!'
        }

        if (!this.objekt.innlevav.Iban || !this.objekt.innlevav.Swift) {
          return 'The Iban and Swift are invalid!'
        }
      }
      return false
    }
  },
  created () {
    var vm = this

    // Set name for the WS channel
    this.presenceChannelName = 'presence-objekt-edit-' + this.objekt.Objektid

    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.varePopoverActive = false
        vm.formPopoverActive = false
      }
    })

    this.loading = true
    this.loadingSave = false
    this.loadingPush = false
    this.processing = false

    bus.$off('seller-invoice-created-from-draft-modal')

    this.setup()
    this.fetch()
    this.objektTitle = this.objekt.title + (this.objekt.subtitle ? ' / ' + this.objekt.subtitle : '')
  },
  mounted () {
    bus.$on('seller-invoice-created-from-draft-modal', (data) => this.onCreatedFromModal(data))
  },
  watch: {
    objekt: function () {
      console.log('oppgjør bilag objekt updated')
      this.setup()
      this.fetchBilag()
    }
  },
  methods: {
    onCreatedFromModal: function (data) {
      bus.$emit('seller-invoice-created', data)
      // this.fetchBilag()
    },
    isRegnskapsBruker: function () {
      return this.hasAccess('accounting')
      // return this.getUser.W_regnskap === 'T'
    },
    getDefaultData: function () {
      const today = new Date()

      return {
        presenceChannelName: null,
        creditable: false,
        loading: true,
        loadingSave: false,
        loadingPush: false,
        processing: false,
        vareList: [],
        varePopoverActive: false,
        formPopoverActive: false,
        bilag: null,
        bilagLines: [],
        currentIndexCount: 0,
        isReturnInvoice: false,
        objektTitle: '',
        isInAuction: false,
        form: {
          Bilagsid: null,
          Bilagstype: 'F',
          Retur: 'F',
          Export: 'F',
          Mvafri: 'F',
          Forfallsdato: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 10),
          bilaglines: []
        }
      }
    },
    creditSetlement: function () {
      let vm = this

      if (!this.isPresenceOwner || !this.isAccounting) {
        return
      }

      this.openConfirm(
        'Krediter oppgjør',
        'Du må velge mellom å bare kreditere i Avanti eller i Avanti & 24Seven',
        'Avanti & 24Seven',
        'Bare Avanti',
        function () {
          ObjektService.creditSetlement(vm.objekt.Objektid)
            .then((response) => {
              // bus.$emit('kunde-kontrakt-objekt-updated', response.data.objekt)
              bus.$emit('seller-invoice-created', response.data)

              vm.loading = true
              vm.fetch()
              vm.closeModal()
              vm.$helpers.showSuccessAlert('Oppgjør er kreditert')
            })
            .catch((err) => {
              console.log('response,', err.response.data)
              vm.closeModal()

              if (err.response.data.errors && err.response.data.errors.twentyfoursevensoaperror) {
                vm.$helpers.showErrorAlert('Feil', err.response.data.errors.twentyfoursevensoaperror)
              } else {
                vm.$helpers.showErrorAlert('Feil', 'Kunne ikke kreditere oppgjøret')
              }
            })
            .then(() => {
              vm.loading = false
            })
        },
        function () {
          ObjektService.creditSetlementWithout24(vm.objekt.Objektid)
            .then((response) => {
              // bus.$emit('kunde-kontrakt-objekt-updated', response.data.objekt)
              bus.$emit('seller-invoice-created', response.data)

              vm.loading = true
              vm.fetch()
              vm.closeModal()
              vm.$helpers.showSuccessAlert('Oppgjør er kreditert')
            })
            .catch((err) => {
              console.log('response,', err.response.data)
              vm.closeModal()

              if (err.response.data.errors && err.response.data.errors.twentyfoursevensoaperror) {
                vm.$helpers.showErrorAlert('Feil', err.response.data.errors.twentyfoursevensoaperror)
              } else {
                vm.$helpers.showErrorAlert('Feil', 'Kunne ikke kreditere oppgjøret')
              }
            })
            .then(() => {
              vm.loading = false
            })
        }
      )
    },
    showBilagsPdf: function () {
      this.openModal('bilag-pdf-modal', {bilag: this.bilag, internalWindow: true}, 'split')
    },
    onValueChange: function ($event, line) {
      let index = this.bilagLines.findIndex(x => x.Internalid === line.Internalid)

      if (index === -1) {
        return
      }

      // console.log('onValueChange::', line.Varenr)

      if (line.Varenr === this.objekt.Objektnr) {
        this.recalcObjekt(line)

        // Based on objekt.Fotokostnad
        this.recalcAuksjonshonorar(line)

        // Based on objekt.Salar
        this.recalcSalar(line)
      } else {
        // All lines - inkl. salar (oppgjør), as based on what's in the input field
        this.recalcLine(line)
      }
    },
    saveAction: function (push = false) {
      if (!this.isPresenceOwner) {
        return
      }

      // Check for psoitive amounts, all lines except Objekt-row.
      const withPositiveAmount = this.bilagLines.filter(item => {
        return item.Varenr !== this.objekt.Objektnr && item.Beloptotal > 0
      })

      const isPushAction = push

      if (withPositiveAmount.length > 0) {
        const vm = this

        this.openConfirm(
          'Advarsel',
          'OBS. Utlegg må legges inn med negativt fortegn.<br/>Vil du lagre uansett?',
          'Lagre',
          'Avbryt',
          function () {
            vm.closeModal()

            if (!isPushAction) {
              vm.saveDraft()
            } else {
              vm.pushToTwentyFour()
            }
          },
          function () {
            vm.closeModal()
          }
        )
      } else if (!isPushAction) {
        return this.saveDraft()
      } else {
        return this.pushToTwentyFour()
      }
    },
    saveDraft: function (skipAlert = false) {
      if (!this.isPresenceOwner) {
        return
      }

      // Start by setting Bilagsid if we have an already saved
      return new Promise((resolve) => {
        this.setFormProcessing(true)
        this.loadingSave = true

        if (this.objekt.OppgjorbilagsIdDraft) {
          this.form.Bilagsid = this.objekt.OppgjorbilagsIdDraft
        }

        // Set all values, except the tilslagspris, to negative values.
        let recalculatedLines = this._.cloneDeep(this.bilagLines)

        let objektlist = []
        objektlist.push({
          Objekt: this.objekt.Objektid,
          bilaglines: recalculatedLines.map((item) => {
            return item
          })
        })

        // Not ok for saving - open modal
        if (this.okForDraftSave) {
          let post = {
            Bilagsid: this.form.Bilagsid,
            Bilagstype: this.form.Bilagstype,
            Export: this.form.Export,
            Mvafri: this.form.Mvafri,
            Retur: this.form.Retur,
            objektlist: objektlist,
            type: 'draft'
          }

          ObjektService.saveObjektBilagSeller(this.objekt.Objektid, post)
            .then((response) => {
              if (!this.loadingPush) {
                const emitData = response.data
                emitData.skipAlert = skipAlert
                bus.$emit('seller-invoice-created', emitData)
                // this.fetchBilag()
              }

              resolve()
            })
            .catch((e) => {
              console.log('e', e.response.status)
              if (e.response.status === 400) {
                let errors = Object.keys(e.response.data.errors).join(',')
                this.$helpers.showErrorAlert('Valideringsfeil', `En eller fler av detaljene rundt oppgjøret er feil. Feil i ${errors}`)
              } else {
                this.$helpers.showErrorAlert('Feil', 'Noe gikk feil i lagringen.')
              }
              console.log('Error From API')
              console.log(JSON.parse(JSON.stringify(e)))

              this.setFormProcessing(false)
              this.loadingSave = false
            })
            .then(() => {
              if (!this.loadingPush) {
                this.loadingSave = false
                this.loadingPush = false
              }
            })
        } else {
          this.setFormProcessing(false)
          this.loadingSave = false

          this.openModal('kunde-kontrakt-objekt-tab-selger-bilag-draft-modal',
            {
              data: this.form,
              state: this.state,
              objektlist: objektlist,
              objekt: this.objekt,
              internalWindow: true
            }
          )
        }
      })
    },
    pushToTwentyFour: function () {
      if (!this.isPresenceOwner) {
        return
      }

      this.loadingPush = true

      // const vm = this

      this.saveDraft(true)
        .then(() => {
          this.setFormProcessing(true)

          console.log('Draft saved - Now push to 247')

          ObjektService.saveToTwentyfour(this.objekt.Objektid)
            .then((response) => {
              bus.$emit('seller-invoice-created', response.data)

              // setTimeout(function () {
              //   vm.fetchBilag()
              // }, 300)
            })
            .catch((e) => {
              if (e.response.status === 400) {
                let errors = Object.values(e.response.data.errors).join(',')
                this.$helpers.showErrorAlert('Valideringsfeil', errors, 2500)
              } else {
                this.$helpers.showErrorAlert('Feil', 'Noe gikk feil i overføring til 24.')
              }
              this.setFormProcessing(false)
              this.loadingPush = false
              this.loadingSave = false
            })
            .then(() => {
              this.loadingPush = false
              this.loadingSave = false
            })
        })
        .catch(() => {
          this.loadingPush = false
          this.loadingSave = false
        })
    },
    openSaveModal: function () {
      if (!this.isPresenceOwner) {
        return
      }

      // Check so we have a Salgspris set.
      let found = this.bilagLines.find(x => x.Varenr === this.objekt.Objektnr)

      if (!found || found.Belop < 1) {
        this.$helpers.showErrorAlert('Feil', 'Du må angi en salgspris som er høyere enn 1')
        return
      }

      // Set all values, except the tilslagspris, to negative values.
      let recalculatedLines = this._.cloneDeep(this.bilagLines)

      let objektlist = []
      objektlist.push({
        Objekt: this.objekt.Objektid,
        bilaglines: recalculatedLines
      })

      this.openModal('kunde-kontrakt-objekt-tab-selger-bilag-modal',
        {
          data: this.form,
          state: this.state,
          objekt: this.objekt,
          objektlist: objektlist,
          internalWindow: true
        },
        'split'
      )
    },
    setup: function () {
      // Check if is return invoice
      const m = this.objekt.Mottaker
      const i = this.objekt.Innlevav

      this.isReturnInvoice = (m && i && m === i)
      this.isInAuction = false

      if (this.objekt.auksjonsdato) {
        const today = moment().format('YYYY-MM-DD')
        const adato = moment(moment(this.objekt.auksjonsdato).format('YYYY-MM-DD'))
        const diff = adato.diff(today)

        if (diff >= 0) {
          this.isInAuction = true
        }
      }
    },
    fetch: function () {
      InstillingerService('vare').dropdownByParams({type: 'S'})
        .then((response) => {
          // Get result and add a used property
          this.vareList = response.data.map(obj => ({...obj, Used: false}))
          this.fetchBilag()
        })
        .catch((e) => {
          this.$helpers.showErrorAlert('Feil', 'Ingen kjøperbilag funnet.')
          console.log(e)

          this.setFormProcessing(false)
          this.loadingSave = false
          this.loadingPush = false
        })
    },
    fetchBilag: function () {
      ObjektService.getObjektBilagSeller(this.objekt.Objektid)
        .then((response) => {
          this.bilag = response.data

          if (this.bilag.bilagslinje) {
            this.bilagLines = []
            let index = -1

            this.bilag.bilagslinje.forEach((line) => {
              line.Internalid = line.Bilagslinjeid
              line.Internaltype = 'old'

              // line.Beloptotal = Math.abs(accounting.formatNumber((line.Beloptotal || 0), {precision: 2, thousand: ''}))
              // line.Pris = Math.abs(accounting.formatNumber(line.Pris || 0, {precision: 2, thousand: ''}))
              // line.Belop = Math.abs(accounting.formatNumber(line.Belop || 0, {precision: 2, thousand: ''}))
              // line.Mvagrunnlag = Math.abs(accounting.formatNumber(line.Belop || 0, {precision: 2, thousand: ''}))
              // line.Mvabelop = Math.abs(accounting.formatNumber(line.Mvabelop || 0, {precision: 2, thousand: ''}))

              line.Beloptotal = accounting.formatNumber((line.Beloptotal || 0), {precision: 2, thousand: ''})
              line.Pris = accounting.formatNumber(line.Pris || 0, {precision: 2, thousand: ''})
              line.Belop = accounting.formatNumber(line.Belop || 0, {precision: 2, thousand: ''})
              line.Mvagrunnlag = accounting.formatNumber(line.Belop || 0, {precision: 2, thousand: ''})
              line.Mvabelop = accounting.formatNumber(line.Mvabelop || 0, {precision: 2, thousand: ''})

              index = this.vareList.findIndex(x => x.data.Varekode === line.Varenr)
              if (index !== -1) {
                this.vareList[index].Used = true
              }

              this.addBilagLine(line)
            })
            if (this.bilag.bilagslinje.filter(x => x.Varenr === 'FOTO').length < 1) {
              this.addAuksjonshonorar()
            }
          }
        })
        .catch((e) => {
          // No bilag found - Make default
          console.log(e)
          this.makeDefaultLines()
        })
        .then(() => {
          this.setFormProcessing(false)
          this.loading = false
          // this.loadingSave = false
          // this.loadingPush = false
        })
    },
    makeDefaultLines: function () {
      // Must be editable
      if (this.state.editableAs !== 'normal' && this.state.editableAs !== 'draft') {
        return
      }

      // 1. Add Objekt
      this.addObjekt()

      // 2. Add Salar
      this.addSalar()

      // 3. Add Kunstnersavgift
      this.addAuksjonshonorar()

      // 4. Add Lagerleie
      if (this.lagerleieWeeks !== null) {
        this.addLagerleie(false)
      }
    },
    addObjekt: function () {
      const index = this.vareList.findIndex(x => x.data.Varekode === 'OBJEKT')

      if (index === -1) {
        return
      }

      const item = this.vareList[index]
      const data = {
        Antall: 1,
        Pris: Math.abs(this.objekt.Salgspris ? parseFloat(this.objekt.Salgspris) : 0),
        Mvapct: item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'O',
        Varenr: this.objekt.Objektnr,
        Beskrivelse: item.data.Beskrivelse || this.objektTitle,
        Internaldel: false,
        Internaledit: true,
        Internalhide: this.state.editableAs === 'draft'
      }

      // Make line
      const line = this.makeVareLine(item, data)
      this.addBilagLine(line)

      // Set vare as used
      this.vareList[index].Used = true
    },
    hasBKH: function () {
      return KUNST_MAPPING.includes(this.objekt.Kategori)
    },
    addSalar: function () {
      const index = this.vareList.findIndex(x => x.data.Varekode === 'OPPGJØR')

      if (index === -1) {
        return
      }
      const item = this.vareList[index]

      let Pris = parseFloat((this.currentObjektPris * (this.objekt.Salar / 100)) || 0)
      // Pris = Pris / (item.data.mva.Mvapct ? (item.data.mva.Mvapct / 100) + 1 : 1)

      const data = {
        Antall: 1,
        Pris: Pris * -1, // Math.abs(Pris),
        Mvapct: item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse || item.data.Varekode,
        Internaldel: false,
        Internaledit: true,
        Internalhide: this.state.editableAs === 'draft'
      }

      // Make line
      const line = this.makeVareLine(item, data)

      this.addBilagLine(line)

      // Set vare as used
      this.vareList[index].Used = true
    },
    addAuksjonshonorar: function () {
      const index = this.vareList.findIndex(x => x.data.Varekode === 'FOTO')

      if (index === -1) {
        return
      }
      const item = this.vareList[index]
      let Pris = parseFloat(this.objekt.Fotokostnad)
      // Pris = Pris / (item.data.mva.Mvapct ? (item.data.mva.Mvapct / 100) + 1 : 1)
      const data = {
        Antall: 1,
        Pris: Pris * -1, // Math.abs(Pris),
        Mvapct: item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse || item.data.Varekode,
        Internaldel: false,
        Internaledit: true,
        Internalhide: false
      }

      // Make line
      const line = this.makeVareLine(item, data)
      this.addBilagLine(line)

      // Set vare as used
      this.vareList[index].Used = true
    },
    addLagerleie: function (deletable) {
      const index = this.vareList.findIndex(x => x.data.Varekode === getLagerleieVarekode(this.objekt.Avdelingsid))
      console.log(index)
      if (index === -1) {
        return
      }

      const item = this.vareList[index]
      const data = {
        Antall: this.lagerleieWeeks.weeks,
        Pris: item.data.Pris ? parseFloat(item.data.Pris) * -1 : 0,
        Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse + ' (' + this.lagerleieWeeks.from + ' - ' + this.lagerleieWeeks.till + ')',
        Internaldel: deletable,
        Internaledit: true
      }

      // Make line
      const line = this.makeVareLine(item, data)
      this.addBilagLine(line)

      // Set vare as used
      this.vareList[index].Used = true
    },
    recalcAuksjonshonorar: function (currLine) {
      // Now recalc salar
      const index = this.bilagLines.findIndex(x => x.Varenr === 'FOTO')

      if (index !== -1) {
        const vidx = this.vareList.findIndex(x => x.data.Varekode === 'FOTO')
        const item = this.vareList[vidx]

        let Pris = parseFloat(this.objekt.Fotokostnad * -1)
        // Pris = Pris / (item.data.mva.Mvapct ? (item.data.mva.Mvapct / 100) + 1 : 1)
        const data = {
          Antall: 1,
          Pris: Pris, // Math.abs(Pris),
          Beskrivelse: this.bilagLines[index].Beskrivelse || item.data.Beskrivelse,
          Mvapct: item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
          Varetype: 'V',
          Varenr: item.data.Varekode,
          Internaldel: false,
          Internaledit: true,
          Internalhide: false
        }

        // Make line
        const line = this.makeVareLine(item, data, true)

        // Merge new data with old, and keep reactivity - hence Object assign
        this.$set(this.bilagLines, index, Object.assign({}, this.bilagLines[index], line))
      }
    },
    addVare: function (item) {
      // Find index of vare in list
      const index = this.vareList.findIndex(x => x.data.Vareid === item.data.Vareid)

      if (index === -1) {
        this.$helpers.showErrorAlert('Feil', 'Kunne ikke finne vare')
        return
      }

      const data = {
        Antall: 1,
        Pris: item.data.Pris ? parseFloat(item.data.Pris * -1) : 0, // Math.abs(item.data.Pris ? parseFloat(item.data.Pris) : 0),
        Mvapct: item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse || item.data.Varekode,
        Internaldel: true,
        Internaledit: true,
        Internalhide: false
      }

      // Make line
      const line = this.makeVareLine(item, data)
      this.addBilagLine(line)

      // Set vare as used
      this.vareList[index].Used = true
    },
    makeVareLine: function (vare, data, onlyRecalc) {
      // Caclulate some values, that are common for all types
      let Pris = data.Pris || 0

      // const Belop = data.Antall * Pris
      // const Mvabelop = Belop * (data.Mvapct ? (data.Mvapct / 100) : 0)

      if (!onlyRecalc) {
        if (this.form.Mvafri === 'F') {
          if (!this.hasBKH() || vare.data.Mvakode !== 'BKH') {
            // eslint-disable-next-line
            if (Pris != 0 && vare.data.Prisinclmva === 'T' && data.Mvapct) {
              Pris = Pris / ((100 + parseInt(data.Mvapct)) / 100)
            }
          }
        }
      } else {
        if (this.form.Mvafri === 'F') {
          if (!this.hasBKH() || vare.data.Mvakode !== 'BKH') {
            // eslint-disable-next-line
            if (Pris != 0 && data.Mvapct) {
              Pris = Pris / ((100 + parseInt(data.Mvapct)) / 100)
            }
          }
        }
      }

      let Mvabelop = 0
      let Belop = data.Antall * Pris

      if (onlyRecalc && data.Varenr === 'SALÆR') {
        Mvabelop = Belop * (data.Mvapct / 100)
      } else if (this.form.Mvafri === 'F' && data.Mvapct) {
        Mvabelop = Belop * (data.Mvapct / 100)
      }

      // const Mvabelop = Belop * (this.form.Mvafri === 'F' && data.Mvapct ? (data.Mvapct / 100) : 0)

      const Beloptotal = Belop + Mvabelop

      let line = {
        Antall: data.Antall,
        // Pris: Math.abs(accounting.formatNumber(Pris, {precision: 2, thousand: ''})),
        // Belop: accounting.formatNumber(Belop, {precision: 2, thousand: ''}),
        // Mvagrunnlag: accounting.formatNumber(Belop, {precision: 2, thousand: ''}),
        // Mvabelop: accounting.formatNumber(Mvabelop, {precision: 2, thousand: ''}),
        // Beloptotal: accounting.formatNumber(Belop + Mvabelop, {precision: 2, thousand: ''}),
        Pris: accounting.formatNumber(Pris, {precision: 2, thousand: ''}),
        Belop: accounting.formatNumber(Belop, {precision: 2, thousand: ''}),
        Mvagrunnlag: accounting.formatNumber(Belop, {precision: 2, thousand: ''}),
        Mvabelop: accounting.formatNumber(Mvabelop, {precision: 2, thousand: ''}),
        Beloptotal: accounting.formatNumber(Beloptotal, {precision: 2, thousand: ''}),

        Mvakode: vare.data.Mvakode,
        Mvapct: data.Mvapct || null,
        Mvatype: vare.data.mva ? vare.data.mva.Mvatype : null,
        Beskrivelse: data.Beskrivelse,
        Bokforgruppekode: vare.data.bokforgruppe ? vare.data.bokforgruppe.Bokforgruppekode : '',
        Enhetskode: vare.data.Enhetskode,
        Vareid: vare.data.Vareid,
        Varenr: data.Varenr,
        Varetype: data.Varetype,
        Internaldel: true
      }

      if (!onlyRecalc) {
        line.Avgiftpct = null
        line.Bilagsid = null
        line.Bilagslinjeid = null
        line.Katalognr = null
        line.Linjenr = null
        line.Rabatbelop = null
        line.Rabatpct = null
        line.eurokurs = null
        line.Internalid = 'new-' + (this.currentIndexCount++)
        line.Internaltype = 'new'
        line.Internaldel = data.Internaldel
        line.Internaledit = data.Internaledit
        line.Internalhide = data.Internalhide
        line.Internalincmva = vare.data.Prisinclmva === 'T'
        line.Gruppe = this.objekt.Kontraktnr + '-' + String(this.objekt.Lopenr).padStart(3, '0')
        line.Objektid = this.objekt.Objektid
        line.Utlevdato = this.objekt.Lev_dato
      }

      return line
    },
    addBilagLine: function (item) {
      this.bilagLines.push(item)
    },
    delBilagLine: function (item) {
      // Find line
      let index = this.bilagLines.findIndex(x => x.Internalid === item.Internalid)

      if (index === -1) {
        // Line does not exist - just do nothing...
        return
      }
      if (item.Bilagslinjeid) {
        this.setFormProcessing(true)
        ObjektService.deleteBilagsLine(this.objekt.Objektid, item.Bilagslinjeid).then(() => {
          this.$helpers.showSuccessAlert('Bilagslinje Slettet')
          this.setFormProcessing(false)
        })
      }

      // Remove from lines
      this.bilagLines.splice(index, 1)

      // Find vare - and put it back to popover menu
      if (item.Vareid) {
        index = this.vareList.findIndex(x => x.data.Vareid === item.Vareid)

        if (index !== -1) {
          this.vareList[index].Used = false
        }
      }
    },
    recalcLine: function (currLine) {
      let index = this.bilagLines.findIndex(x => x.Internalid === currLine.Internalid)

      if (index !== -1) {
        const vidx = this.vareList.findIndex(x => x.data.Varekode === currLine.Varenr)
        const item = this.vareList[vidx]

        let Pris = parseFloat(currLine.Beloptotal || 0)

        const data = {
          Antall: 1,
          Pris: Pris, // Math.abs(Pris),
          Mvapct: item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
          Varetype: 'V',
          Varenr: item.data.Varekode,
          Beskrivelse: this.bilagLines[index].Beskrivelse || item.data.Beskrivelse,
          Internaldel: true,
          Internaledit: true
        }

        // Make line
        const line = this.makeVareLine(item, data, true)

        // Merge new data with old, and keep reactivity - hence Object assign
        this.$set(this.bilagLines, index, Object.assign({}, this.bilagLines[index], line))
      }
    },
    recalcObjekt: function (currLine) {
      // Recalc Objekt
      let index = this.bilagLines.findIndex(x => x.Varenr === this.objekt.Objektnr)
      let vidx = null
      let item = null
      let data = null
      let line = null

      if (index !== -1) {
        vidx = this.vareList.findIndex(x => x.data.Varekode === 'OBJEKT')
        item = this.vareList[vidx]

        data = {
          Antall: 1,
          Pris: Math.abs(parseFloat(currLine.Beloptotal || 0)),
          Mvapct: item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
          Varetype: 'O',
          Varenr: this.objekt.Objektnr,
          Beskrivelse: this.bilagLines[index].Beskrivelse || this.objektTitle,
          Internaldel: false,
          Internaledit: true
        }

        // Make line
        line = this.makeVareLine(item, data, true)

        this.$set(this.bilagLines, index, Object.assign({}, this.bilagLines[index], line))
      }
    },
    sortLinevalues: function (a, b) {
      let aText = a.data.Beskrivelse || a.val
      let bText = b.data.Beskrivelse || b.val
      return aText.localeCompare(bText)
    },
    recalcSalar: function (currLine) {
      // Now recalc salar
      const index = this.bilagLines.findIndex(x => x.Varenr === 'OPPGJØR')

      if (index !== -1) {
        const vidx = this.vareList.findIndex(x => x.data.Varekode === 'OPPGJØR')
        const item = this.vareList[vidx]

        // let Pris = currLine.Beloptotal
        let Pris = parseFloat((this.currentObjektPris * ((this.objekt.Salar / 100) * -1)) || 0)
        // Pris = Pris / (item.data.mva.Mvapct ? (item.data.mva.Mvapct / 100) + 1 : 1)

        const data = {
          Antall: 1,
          Pris: Pris, // Math.abs(Pris),
          Mvapct: item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
          Varetype: 'V',
          Varenr: item.data.Varekode,
          Beskrivelse: this.bilagLines[index].Beskrivelse || item.data.Beskrivelse,
          Internaldel: false,
          Internaledit: true
        }

        // Make line
        const line = this.makeVareLine(item, data, true)

        // Merge new data with old, and keep reactivity - hence Object assign
        this.$set(this.bilagLines, index, Object.assign({}, this.bilagLines[index], line))
      }
    },
    showErrorMessage: function () {
      return this.objekt.last_oppgjor_logg && this.objekt.last_oppgjor_logg.Failed && !this.objekt.last_oppgjor_logg.Melding.includes('Already updated before')
    },
    toggleVarePopover: function () {
      if (!this.isPresenceOwner) {
        return
      }

      this.varePopoverActive = !this.varePopoverActive
      this.formPopoverActive = false
    },
    toggleFormPopover: function () {
      this.formPopoverActive = !this.formPopoverActive
      this.varePopoverActive = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektTabSelgerBilag.vue